/**
 * Home画面に出すスタッフブログ
 *
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
	StyledHomeColumn,
	StyledTitle,
	StyledContainerHomeBlogList,
} from './Home/Styled/StyledHomeComponents'
import StaffBlogList from './StaffBlogList'

class HomeStaffBlog extends Component {
	render() {
		const { data } = this.props

		if (!data.loaded) {
			return null
		}

		if (!Object.keys(data).length) {
			return null
		}
		const listBlog = data.data ? data.data.list : []

		return (
			<StyledHomeColumn column={2} gap={24}>
				<StyledTitle>運営ブログ
					<Link to="/home/staffblog/1" className="link-to-staff">
						すべて見る
					</Link>

				</StyledTitle>
				<StyledContainerHomeBlogList>
					<StaffBlogList data={listBlog} />
				</StyledContainerHomeBlogList>
				{/* <Link to="/home/staffblog/1" className="link-to-staff">
					運営ブログをもっと見る
				</Link> */}
			</StyledHomeColumn>
		)
	}
}

const mapStateToProps = (state) => {
	return {}
}

export default connect(mapStateToProps)(HomeStaffBlog)
